module.exports = " <div class=vc-page> <header-bar> <icon-button slot=left @click=back() icon=arrow_back></icon-button> <span>Search Bar</span> </header-bar> <search-bar :focus.sync=focus></search-bar> <scroll-view> <overlay v-if=focus></overlay> </scroll-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/searchBar.vue
 ** module id = 407
 ** module chunks = 1
 **/